import { useState } from "react";
import { Upload, Spin } from "antd";
import { useDispatch } from "react-redux";
import { setEntity } from "../features/cartransferSlice";
import { useUpdateCartransferFile } from "../hooks/useUpdateCartransferFile";
import { upload } from "../api/parseDocsService";
import Resizer from "react-image-file-resizer";
import { parseDateFields } from "./parseFormfields";

const { Dragger } = Upload;

const UploadFile = ({
  cartransferId,
  type,
  action,
  entity,
  ws,
  label = "Subir",
  onError,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const updateCartransferFile = useUpdateCartransferFile();

  const resizeFile = (file, type, mimetype) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file, // Is the file of the image which will resized.
        1500, // Is the maxWidth of the resized new image.
        1500, // Is the maxHeight of the resized new image.
        mimetype, // Is the compressFormat of the resized new image.
        50, // Is the quality of the resized new image.
        0, // Is the degree of clockwise rotation to apply to uploaded image.
        (uri) => {
          // Is the callBack function of the resized new image URI.
          resolve(uri);
        },
        type // Is the output type of the resized new image.
      );
    });

  const uploadImage = async (options) => {
    const { onSuccess, onError, file } = options;
    const fmData = new FormData();
    const mimetype = file.type.split("/").slice(-1)[0];

    fmData.append("entity", entity);
    fmData.append("cartransferId", cartransferId);

    if (type !== "application/pdf") {
      const rs = await resizeFile(file, "file", mimetype);
      fmData.append("file", rs);
    } else {
      fmData.append("file", file);
    }

    try {
      setLoading(true);
      const res = await upload(action, fmData);
      console.log(res);
      onSuccess("Ok");

      //monkey shitty patch you have to refactor
      console.log('🔍 Upload response:', res);
      console.log('🔍 Response data type:', typeof res.data);
      console.log('🔍 Response data:', res.data);
      
      if (typeof res.data === "object") {
        console.log('🔍 Parsing fields for entity:', entity);
        const parsedFields = parseDateFields(res.data);
        console.log('🔍 Parsed fields:', parsedFields);
        dispatch(
          setEntity({
            entity,
            data: parsedFields,
          })
        );
        console.log('🔍 Entity updated in Redux store');
      }

      if (typeof res.data === "string") {
        updateCartransferFile.mutate({
          id: cartransferId,
          data: { [`folder_${entity}`]: res.data }
        });
      }
      //monkey shitty patch you have to refactor

      ws && ws(entity, res.data);
    } catch (err) {
      console.log("Error: ", err);
      const errorMessage = err.response?.data?.message || err.message || "Error al subir el archivo";
      
      // Llamar al callback de error si está disponible
      if (onError) {
        onError({ message: errorMessage, originalError: err });
      }
      
      onError({ err });
    }
    setLoading(false);
  };

  return (
    <div className="container">
      {loading ? (
        <Spin />
      ) : (
        <Dragger
          accept={type}
          customRequest={uploadImage}
          multiple={false}
          showUploadList={false}
        >
          {<div>{label}</div>}
        </Dragger>
      )}
    </div>
  );
};

export default UploadFile;
